module.exports = __webpack_public_path__ + "1031a1e67aea1d5e03709b2415438935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-wow.png
// module id = 2086
// module chunks = 4